export {default as CookClass} from './CookClassBox';



// WEBPACK FOOTER //
// ./src/components/CookClasses/CookClass/index.js